const initialState = () => ({
  isOpened: true
});

const ACTION_KEY = 'PERFORM_VISIT_STEPS_FEEDBACK_SCREEN_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      return {
        ...state,
        isOpened: true
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return {
        isOpened: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
